(function () {
    'use strict';

    angular
        .module('app')
        .component('categoriaRssListAdmin', {
            templateUrl: 'app/components/feedrss/admin/categoriarss/categoria-rss-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                permisos: '<'
            }
        });

    /* @ngInject */
    function Controller($stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                        ModalService, CategoriaRss, Permisos) {
        var vm = this;

        vm.item = CategoriaRss;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: undefined
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {id: 'asc'}
        }, NgTableHelper.settings(vm));

        if (Permisos.tienePermisos('create', vm.permisos)) {
            // Eliminar
            vm.showRemoveConfirmation = function (id) {
                ModalService.open({
                        templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                        controller: 'EntityDeleteModalController',
                        controllerAs: 'ctrl',
                        resolve: {
                            /* @ngInject */
                            item: function (CategoriaRss) {
                                return CategoriaRss.get({id: id}).$promise;
                            },
                            params: function () {
                                return {
                                    title: 'feedsRss.categoriaRss.admin.delete.title',
                                    body: 'feedsRss.categoriaRss.admin.delete.confirm',
                                    property: 'nombre'
                                };
                            }
                        }
                    }
                ).result.then(function () {
                    vm.tableParams.reload();
                });
            };
        }
    }

})();
